import { ParsedUrlQuery } from 'querystring';

const makeKeyValue = (k, v) => {
  if (v === 'null') {
    return `${k} = 0`;
  }

  return `${k}:${v}`;
};

const makeFacetFilters = (obj: ParsedUrlQuery): ReadonlyArray<readonly string[]> => {
  const facetFilters = Object.keys(obj)
    .filter((k) => Array.isArray(obj[k]) ? obj[k].length : obj[k])
    .map((k) => {
      const v = obj[k];

      if (Array.isArray(v)) {
        return v.map(i => makeKeyValue(k, i));
      } else {

        return [makeKeyValue(k, v)];
      }
    });

  return facetFilters;
};

export default makeFacetFilters;
